import React, { Component } from 'react';
import { connect } from 'react-redux';
import Popup from 'reactjs-popup';

import {
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem /*, ButtonGroup, Button*/
} from 'reactstrap';

import { standardList, brandList, countryList } from '../../app.values';

import Accordion from '../../components/Accordion';
import AccordionItem from '../../components/Accordion/components/AccordionItem';
import Spinner from '@components/LoadingStyles/Spinner';

import CalculateAnchorSelection from './components/CalculateAnchorSelection';
import CalculateNailsSelection from './components/CalculateNailsSelection';
import CalculateHeader from './components/CalculateHeader';
import CalculateInstallationData from './components/CalculateInstallationData';
import CalculateInstallationMethod from './components/CalculateInstallationMethod';
import CalculateLoads from './components/CalculateLoads';
import CalculateResultsOfDesign from './components/CalculateResultsOfDesign';
import CalculateThickness from './components/CalculateThickness/CalculateThickness';
import RebarDesignCalculation from './components/RebarDesignCalculation';
import './styles.scss';
import './../../index.scss';

import calculateTabService from '@services/requests/calculate-tab.service';
import { APP_TYPES, BRAND, APP_STATES } from '@config';
import { REBAR } from "../../reducers/selectors/design/types";

import { generateReportGr, updateClientUnits } from '@reducers/web-services/report/actions';
import { setSpinner, setSceneSpinner, setReportProgress } from '@reducers/web-services/calculate/actions';
import { APP_TEXTS } from '../../texts/texts';
// import { isICCorCSA } from '@services/helper.service';
import { EventManager, EVENTS } from '@components/Events/events';
import { setCompressionZone } from '@reducers/options/panel/actions';
import tabs from './../../App/tabs';
import {
  cancelFEMCalculation,
  scrollToSelectedResult,
  setReportContactName,
  setReportMailAddress,
  setReportComment,
  setReportLanguage,
  setReportProjectName,
  setReportFasteningPoint,
  setReportLocation,
  setReportCompanyName,
  setReportPhoneNumber,
  setReportDimensions3D
} from '@reducers/selectors/calculate/actions';
import CalculateProfileResistance from './components/CalculateProfileResistance';
import Input from '@components/Input';
import initService from '@services/requests/init.service';
import ProgressControl from '@components/LoadingStyles/ProgressControl';
import { switchToReport3DDimensions } from '@reducers/options/actions';
import { PerspectiveCameraTypes, setPerspectiveCameraType } from '@reducers/camera/actions';
import { initCalculateTab } from '@reducers/web-services/calculate/actions';
import CalculateNailHeader from './components/CalculateNailHeader';
import CalculateEurocode5Design from './components/CalculateEurocode5Design';

const calcModes = {
  CONCISE: 'concise',
  DETAILED: 'detailed'
};

const DOC_TYPES = {
  ETA: 'ETA',
  ESR: 'ESR',
  BIM: 'BIM',
  ACAD: 'ACAD',
  ANZ_DOC: 'ANZ_DOC',
  STEP: 'STEP'
};

class Calculate extends Component {

  constructor(props) {
    super(props);

    this.onTabChanged = this.onTabChanged.bind(this);
    // EventManager.addListener(EVENTS.TAB_SWITCHED, this.onTabChanged);
  }

  state = {
    isPending: true,
    mode: calcModes.CONCISE,
    isCalculateTab: false,
    displayReportSettings: false,
    reportLanguages: []
  };

  componentDidMount() {
    EventManager.addListener(EVENTS.TAB_SWITCHED, this.onTabChanged);
  }

  componentWillUnmount() {
    EventManager.removeListener(EVENTS.TAB_SWITCHED, this.onTabChanged);
  }

  componentDidUpdate(prevProps) {
    if (this.props.appStatus === APP_STATES.INITIALIZED &&
      (this.props.country !== prevProps.country ||
        this.props.language !== prevProps.language ||
        (prevProps.appStatus === APP_STATES.REVIEW_OPTIONS && this.props.reportOptions.language !== this.props.language)) ||
      (this.state.reportLanguages && this.state.reportLanguages.length <= 0) || // Switching to 2D Editor will reset state
      (prevProps.appStatus === APP_STATES.LOADING_NEW_STATE)) { // Reload languages after opening a project
      this.getLanguages(this.props.country);
    }

    if (this.props.reportProgress >= 100) { // let it show 100% for half second
      setTimeout(() => this.props.setReportProgress(-1), 500);
    }
    if (this.props.isEmptyList && !prevProps.isEmptyList && this.state.mode === calcModes.DETAILED) {
      this.switchMode({ target: { name: calcModes.CONCISE } }); // pseudo event args
    }
  }

  render() {
    return (
      <Row>
        <Col sm="12">
          <div className="calculation">
            {(this.props.reportProgress >= 0) ? (
              <ProgressControl
                animated={true}
                value={this.props.reportProgress}
                label={`${APP_TEXTS.LABEL_SPINNER_LOADING.Content} ${this.props.reportProgress}%`}
              />
            ) : ((this.props.isWaiting) && <Spinner />)
            }
            <section className="list-type calculation-header d-flex align-items-center Calculate__controls">
              <div className="btn-group">
                <button
                  className={`btn ${this.state.mode === calcModes.CONCISE && 'ToggleButton--active'}`}
                  name={calcModes.CONCISE}
                  onClick={this.switchMode}
                >
                  {APP_TEXTS.LABEL_CONCISE_VIEW.Content}
                </button>

                <button
                  className={`btn ${this.state.mode === calcModes.DETAILED && 'ToggleButton--active'}`}
                  name={calcModes.DETAILED}
                  onClick={(e) => {
                    if (!this.props.isEmptyList)
                      this.switchMode(e);
                  }}
                >
                  {APP_TEXTS.LABEL_DETAILED_VIEW.Content}
                </button>
              </div>

              <div className="calculate__button-grup">
                {(Number(this.props.designStandard) === standardList['EU'] ||
                  Number(this.props.designStandard) === standardList['AnnexC']) &&
                  this.props.appType !== APP_TYPES.REBAR_REINFORCEMENT &&
                  !this.props.isEmptyList && this.props.selectedAnchor ? (
                  <UncontrolledDropdown nav className="btn btn-sm calculate__button calculate__button_orange calculate__dropdown">
                    <DropdownToggle nav caret>
                      PDF
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem onClick={() => {
                        this.onGenerateReport = () => {
                          this.props.generateReportGr(
                            this.props.selectedAnchor.IndexProduct,
                            this.props.selectedAnchor.IndexDiameter,
                            this.props.selectedAnchor.IndexType,
                            this.props.selectedNail ? this.props.selectedNail.IndexProduct : null,
                            this.props.selectedNail ? this.props.selectedNail.IndexDiameter : null,
                            this.props.selectedNail ? this.props.selectedNail.IndexType : null,
                            null);
                        };
                        this.setState({ displayReportSettings: true });
                      }}>
                        {APP_TEXTS.CALCULATE_REPORT_SHORT.Content}
                      </DropdownItem>
                      <DropdownItem onClick={() => {
                        this.onGenerateReport = () => {
                          this.props.generateReportGr(
                            this.props.selectedAnchor.IndexProduct,
                            this.props.selectedAnchor.IndexDiameter,
                            this.props.selectedAnchor.IndexType,
                            this.props.selectedNail ? this.props.selectedNail.IndexProduct : null,
                            this.props.selectedNail ? this.props.selectedNail.IndexDiameter : null,
                            this.props.selectedNail ? this.props.selectedNail.IndexType : null,
                            null,
                            false);
                        };
                        this.setState({ displayReportSettings: true });
                      }}>
                        {APP_TEXTS.CALCULATE_REPORT_DETAILED.Content}
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                ) : (
                  <button
                    className="btn btn-sm calculate__button calculate__button_orange"
                    onClick={() => {
                      this.onGenerateReport = () => {
                        if (this.props.appType !== APP_TYPES.REBAR_REINFORCEMENT)
                          this.props.generateReportGr(
                            this.props.selectedAnchor.IndexProduct,
                            this.props.selectedAnchor.IndexDiameter,
                            this.props.selectedAnchor.IndexType,
                            this.props.selectedNail ? this.props.selectedNail.IndexProduct : null,
                            this.props.selectedNail ? this.props.selectedNail.IndexDiameter : null,
                            this.props.selectedNail ? this.props.selectedNail.IndexType : null,
                            null);
                        else
                          this.props.generateReportGr(
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            this.props.selectedAnchor.DatabaseName);
                      };
                      this.setState({ displayReportSettings: true });
                    }}
                    disabled={this.props.isEmptyList || !this.props.selectedAnchor}
                  >
                    PDF
                  </button>
                )}

                <Popup
                  modal={true}
                  open={this.state.displayReportSettings}
                  closeOnDocumentClick={false}
                  className="settings"
                >
                  {close => (
                    <React.Fragment>
                      <h4 className="settings-header">{APP_TEXTS.CALCULATE_REPORT_SHEET_SETTINGS.Content}</h4>
                      <div className="settings-text">
                        <p>{APP_TEXTS.CALCULATE_REPORT_SHEET_INFO.Content}</p>
                        <hr />
                        <label htmlFor="show-dimensions-3d mt-2 mb-2">
                          {APP_TEXTS.CALCULATE_REPORT_SHOW_DIM_3D.Content}
                          <input
                            className="form-control"
                            type="checkbox"
                            id="show-dimensions-3d"
                            checked={this.props.reportOptions.showDim3d}
                            onChange={(e) => { this.props.setReportDimensions3D(e.target.checked); }}
                          />
                        </label>
                        <hr />
                        <h4>{APP_TEXTS.CALCULATE_REPORT_PROJECT_DETAILS.Content}</h4>
                        <form id="project-details-form" className="list-type">
                          <Input
                            className=""
                            id="project-name"
                            prefix={APP_TEXTS.CALCULATE_REPORT_PROJECT_NAME.Content}
                            value={this.props.reportOptions.projectName}
                            onUpdate={value => this.props.setReportProjectName(value)} />
                          <Input
                            className=""
                            id="fastening-point"
                            prefix={APP_TEXTS.CALCULATE_REPORT_FASTENING_POINT.Content}
                            value={this.props.reportOptions.fasteningPoint}
                            onUpdate={value => this.props.setReportFasteningPoint(value)} />
                          <Input
                            className=""
                            id="location"
                            prefix={APP_TEXTS.CALCULATE_REPORT_LOCATION.Content}
                            value={this.props.reportOptions.location}
                            onUpdate={value => this.props.setReportLocation(value)} />
                          <Input
                            className=""
                            id="contact-name"
                            prefix={APP_TEXTS.CALCULATE_REPORT_CONTACT_NAME.Content}
                            value={this.props.reportOptions.contactName}
                            onUpdate={value => this.props.setReportContactName(value)} />
                          <Input
                            className=""
                            id="company-name"
                            prefix={APP_TEXTS.CALCULATE_REPORT_COMPANY_NAME.Content}
                            value={this.props.reportOptions.companyName}
                            onUpdate={value => this.props.setReportCompanyName(value)} />
                          <Input
                            className=""
                            id="phone-number"
                            prefix={APP_TEXTS.CALCULATE_REPORT_PHONE_NUMBER.Content}
                            value={this.props.reportOptions.phoneNumber}
                            onUpdate={value => this.props.setReportPhoneNumber(value)} />
                          <Input
                            className=""
                            id="email-address"
                            prefix={APP_TEXTS.CALCULATE_REPORT_MAIL_ADDRESS.Content}
                            value={this.props.reportOptions.mailAddress}
                            onUpdate={value => this.props.setReportMailAddress(value)} />
                          <Input
                            className=""
                            id="comment"
                            prefix={APP_TEXTS.CALCULATE_REPORT_COMMENT.Content}
                            value={this.props.reportOptions.comment}
                            onUpdate={value => this.props.setReportComment(value)} />
                          <hr />
                          <label htmlFor="language-settings">
                            <span><b>{APP_TEXTS.CALCULATE_REPORT_LANGUAGE_SETTINGS.Content}</b></span>
                            <select
                              id="language-settings"
                              className="form-control"
                              onChange={e => this.props.setReportLanguage(e.target.value)}
                              value={this.props.reportOptions.language}
                            >
                              {this.state.reportLanguages && this.state.reportLanguages.map(lang => (
                                <option
                                  value={Number(lang.InternalName)}
                                  key={Number(lang.InternalName)}
                                >
                                  {lang.RunName}
                                </option>
                              ))}
                            </select>
                          </label>
                        </form>
                      </div>
                      <div className="settings-footer">
                        <button
                          type="submit"
                          form="project-details-form"
                          onClick={(e) => {
                            e.preventDefault();
                            if (e.target.form) {
                              this.props.setReportProjectName(e.target.form["project-name"].value);
                              this.props.setReportFasteningPoint(e.target.form["fastening-point"].value);
                              this.props.setReportLocation(e.target.form.location.value);
                              this.props.setReportContactName(e.target.form["contact-name"].value);
                              this.props.setReportCompanyName(e.target.form["company-name"].value);
                              this.props.setReportPhoneNumber(e.target.form["phone-number"].value);
                              this.props.setReportMailAddress(e.target.form["email-address"].value);
                              this.props.setReportComment(e.target.form.comment.value);
                            }
                            this.setState({ displayReportSettings: false });
                            this.onGenerateReport();
                            close();
                          }}
                          className="btn btn-sm settings-button"
                          disabled={!this.props.selectedAnchor}
                        >
                          {APP_TEXTS.ANCHOR_SELECTION_OK.Content}
                        </button>
                        <button
                          onClick={() => {
                            this.setState({ displayReportSettings: false });
                            close();
                          }}
                          className="btn btn-sm settings-button"
                          disabled={!this.props.selectedAnchor}
                        >
                          {APP_TEXTS.BUTTONS_CANCEL.Content}
                        </button>
                      </div>
                    </React.Fragment>
                  )}
                </Popup>

                {BRAND === brandList.Redhead ||
                  (BRAND === brandList.Ramset && Number(this.props.designStandard) === standardList['ICC.Post']) ? (
                  <button
                    onClick={() => this.getDoc(DOC_TYPES.ESR)}
                    className="btn btn-sm calculate__button"
                    disabled={this.props.isEmptyList || !this.props.selectedAnchor}
                  >
                    ESR
                  </button>
                ) : (Number(this.props.designStandard) === standardList['ANZ'] &&
                  this.props.appType !== APP_TYPES.REBAR_REINFORCEMENT ? (
                  <button
                    onClick={() => this.getDoc(DOC_TYPES.ANZ_DOC)}
                    className="btn btn-sm calculate__button"
                    disabled={this.props.isEmptyList || !this.props.selectedAnchor}
                  >
                    DOC
                  </button>
                ) : (
                  <button
                    onClick={() => this.getDoc(DOC_TYPES.ETA)}
                    className="btn btn-sm calculate__button"
                    disabled={this.props.isEmptyList || !this.props.selectedAnchor}
                  >
                    {Number(this.props.designStandard) === standardList['Masonry'] ||
                      Number(this.props.designStandard) === standardList['AS3600'] ||
                      Number(this.props.designStandard) === standardList['ANZ'] ||
                      (Number(this.props.designStandard) === standardList['AS5216'] &&
                        this.props.appType === APP_TYPES.REBAR_REINFORCEMENT) ?
                      "DOC" : "ETA"
                    }
                  </button>
                )
                )}

                {BRAND !== brandList.Ramset && BRAND !== brandList.Redhead && (
                  <React.Fragment>
                    {this.props.appType !== APP_TYPES.REBAR_REINFORCEMENT && (
                      <button
                        onClick={() => this.getDoc(DOC_TYPES.BIM)}
                        className="btn btn-sm calculate__button"
                        disabled={this.props.isEmptyList || !this.props.selectedAnchor}
                      >
                        BIM
                      </button>
                    )}
                  </React.Fragment>
                )}

                {this.props.appType !== APP_TYPES.REBAR_REINFORCEMENT && (
                  <React.Fragment>
                    {(BRAND !== brandList.Redhead && (BRAND !== brandList.Ramset ||
                      (parseInt(this.props.country) === countryList['Australia'] ||
                        parseInt(this.props.country) === countryList['New Zealand']))) && (
                        <button
                          onClick={() => this.getDoc(DOC_TYPES.ACAD)}
                          className="btn btn-sm calculate__button"
                          disabled={this.props.isEmptyList || !this.props.selectedAnchor}
                        >
                          ACAD
                        </button>
                      )}
                    {(BRAND === brandList.Spit || (BRAND === brandList.Ramset &&
                      (parseInt(this.props.country) === countryList['Australia'] ||
                        parseInt(this.props.country) === countryList['New Zealand']))) && (
                        <button
                          onClick={() => this.getDoc(DOC_TYPES.STEP)}
                          className="btn btn-sm calculate__button"
                          disabled={this.props.isEmptyList || !this.props.selectedAnchor}
                        >
                          STEP
                        </button>
                      )}
                  </React.Fragment>
                )}
              </div>
            </section>
          </div>

          {this.state.mode === calcModes.CONCISE &&
            <div>
              <section className="list-type">
                <CalculateAnchorSelection />
              </section>

              {this.props.appType === APP_TYPES.WOOD_CONNECTION && (
                <section className="list-type">
                  <CalculateNailsSelection />
                </section>
              )}
              {this.props.isEmptyList ? (
                <React.Fragment>
                  {!this.props.isWaiting && (
                    <section className="list-type">
                      <button className="GeneralSettings__button ml-2" onClick={this.props.initCalculateTab}>
                        {APP_TEXTS.HEADER_CALCULATE.Content}
                      </button>
                    </section>
                  )}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <section className="list-type">
                    <CalculateHeader />
                  </section>
                  {this.props.appType === APP_TYPES.WOOD_CONNECTION && (
                    <section className="list-type">
                      <CalculateNailHeader />
                    </section>
                  )}
                </React.Fragment>
              )}
            </div>
          }

          {this.state.mode === calcModes.DETAILED &&
            <div>
              <section className="list-type">
                <CalculateHeader />
                {this.props.appType === APP_TYPES.WOOD_CONNECTION && (
                  <CalculateNailHeader />
                )}
              </section>

              <section className="list-type">
                <Accordion className="application__accordion" appStatus={this.props.appStatus}>
                  {this.props.appType !== APP_TYPES.REBAR_REINFORCEMENT && (
                    <AccordionItem id="calculate-loads" title={APP_TEXTS.HEADER_LOADS.Content}>
                      <CalculateLoads />
                    </AccordionItem>
                  )}
                  {this.props.appType === APP_TYPES.WOOD_CONNECTION && (
                    <AccordionItem
                      id="calculate-eurocode5-design"
                      title={APP_TEXTS.CALCULATE_EUROCODE5_TITLE.Content}
                    >
                      <CalculateEurocode5Design />
                    </AccordionItem>
                  )}
                  {this.props.appType !== APP_TYPES.REBAR_REINFORCEMENT && (
                    <AccordionItem
                      id="calculate-results-of-design"
                      title={`${APP_TEXTS.RESULTS_OF_DESIGN.Content} ${this.props.selectedAnchor ?
                        this.props.selectedAnchor.DesignMethodUsed : 'unknown'}`}
                    >
                      <CalculateResultsOfDesign />
                    </AccordionItem>
                  )}

                  {this.props.appType === APP_TYPES.REBAR_REINFORCEMENT && (
                    <AccordionItem id="design-calculation-xxx" title={`Design calculation ${this.props.rebarDesignExpanderTitle}`}>
                      <RebarDesignCalculation />
                    </AccordionItem>
                  )}

                  <AccordionItem id="calculate-installation-data" title={APP_TEXTS.INSTALLATION_DATA.Content}>
                    <CalculateInstallationData />
                  </AccordionItem>

                  {this.props.appType !== APP_TYPES.REBAR_REINFORCEMENT &&
                    Number(this.props.designStandard) !== standardList['ICC.Cast'] && (
                      <AccordionItem id="calculate-installation-method" title={APP_TEXTS.INSTALLATION_METHOD.Content}>
                        <CalculateInstallationMethod />
                      </AccordionItem>
                    )}
                  {this.props.appType !== APP_TYPES.REBAR_REINFORCEMENT &&
                    this.props.profileFamily !== 'None' && (
                      <AccordionItem id="calculate-eta-document" title={APP_TEXTS.CHECK_BASE_PLATE_THICKNESS.Content}>
                        <CalculateThickness />
                      </AccordionItem>
                    )}
                  {this.props.checkProfileResistance && (
                    <AccordionItem id="calculate-profile-resistance" title={APP_TEXTS.CALCULATE_PROFILE_RESISTANCE.Content}>
                      <CalculateProfileResistance />
                    </AccordionItem>
                  )}
                </Accordion>
              </section>
            </div>
          }
        </Col>
      </Row>
    );
  }

  switchMode = e => {
    this.setState({ mode: e.target.name, isPending: false });
    if (e.target.name === calcModes.CONCISE)
      this.props.scrollToSelectedResult(true);
  }

  getDoc = doc => {
    calculateTabService.getFile(this.props.appType !== APP_TYPES.REBAR_REINFORCEMENT ?
      this.props.selectedAnchor.AnchorInternalName : this.props.selectedAnchor.DatabaseName, doc).then(res => {
        if (res) {
          calculateTabService.openFile(res);
        }
      });
  };

  generateReport = () => {
    if (this.props.appType === APP_TYPES.REBAR_REINFORCEMENT) {
      calculateTabService.generateReport({
        rebarName: this.props.selectedAnchor.DatabaseName,
      });
    } else {
      calculateTabService.generateReport({
        //config: this.config,
        anchorId: this.props.selectedAnchor.AnchorInternalName,
        diameter: this.props.selectedAnchor.IndexDiameter,
        type: this.props.selectedAnchor.IndexType
      });
    }
  }

  onTabChanged(tab) {
    if (tabs.CALCULATE === tab) {
      this.setState({ isCalculateTab: true });
    }
    else if (this.state.isCalculateTab) { // Switched from CALCULATE to any other tab
      this.setState({ isCalculateTab: false });
      this.props.resetCompression();
      if (this.props.isCalculating)
        this.props.cancelFEMCalculation();
    }
  }

  getLanguages(country) {
    if (country) {
      initService.getLanguages(country).then((res) => {
        if (res && res.length) {
          if (!this.state.reportLanguages || this.state.reportLanguages.length !== res.length ||
            res.some((val, idx) => val.InternalName !== this.state.reportLanguages[idx].InternalName)) {
            this.setState({ reportLanguages: res });
          }
          if (!this.props.reportOptions || !this.props.reportOptions.language ||
            !res.find(lang => Number(lang.InternalName) === Number(this.props.reportOptions.language))) {
            if (res.find(lang => Number(lang.InternalName) === Number(this.props.language)))
              this.props.setReportLanguage(this.props.language); // set the user's language as default
            else
              this.props.setReportLanguage(res[0].InternalName);
          }
        }
      });
    }
  }

}

const mapState = state => {
  if (state.main.appType) {
    const calculateState = state.selectors.calculate[state.main.appType] || {};
    const designState = state.selectors.design[state.main.appType] || {};
    const applicationState = state.selectors.application[state.main.appType] || {};

    return {
      appType: state.main.appType,
      appStatus: state.main.status,
      designStandard: state.main.localization.designStandard,
      country: state.main.localization.country,
      language: state.main.localization.language,
      selectedAnchor: calculateState.gridSelectedItem,
      selectedNail: calculateState.gridSelectedNailItem,
      isWaiting: state.webServices.calculate.isWaiting,
      checkProfileResistance: designState.checkProfileResistance,
      reportOptions: state.selectors.calculate.report,
      reportProgress: state.webServices.calculate.reportProgress,
      isEmptyList: state.main.appType === APP_TYPES.WOOD_CONNECTION
        ? (!state.webServices.calculate.grid ||
          !state.webServices.calculate.grid.AnchorDesignResults ||
          state.webServices.calculate.grid.AnchorDesignResults.length <= 0)
        : (!state.webServices.calculate.grid ||
          state.webServices.calculate.grid.length <= 0),
      profileFamily: (applicationState.profile && applicationState.profile.family) ?
        applicationState.profile.family : 'None',
      rebarDesignExpanderTitle: (() => {
        if (+state.main.localization.designStandard === +standardList['AS3600']) {
          return 'AS3600:2018';
        }

        switch (state.selectors.design[APP_TYPES.REBAR_REINFORCEMENT].design) {
          case REBAR.types.EUROCODE_2_SEISMIC:
          case REBAR.types.EUROCODE_2: {
            return 'EC2';
          }
          case REBAR.types.EUROCODE_2_FIRE: {
            return 'EC2 + Fire calculation';
          }
          case REBAR.types.VARIO_ADHESIVE_METHOD: {
            return 'VARIO';
          }
          default: {
            return 'xxxx';
          }
        }
      })(),
      isCalculating: (() => {
        if (state.main.appType !== APP_TYPES.REBAR_REINFORCEMENT) {
          return state.selectors.calculate[state.main.appType].FEM.isCalculating;
        } else {
          return false;
        }
      })()
    };
  }

  return {
    appType: state.main.appType
  };
};

const mapDispatch = dispatch => ({
  generateReportGr: async (productIdx, diameterIdx, typeIdx, nailProductIdx, nailDiameterIdx, nailTypeIdx, rebarName, isDefault = true) => {
    dispatch(setSpinner(true));
    dispatch(setSceneSpinner(true));
    dispatch(switchToReport3DDimensions(true));
    dispatch(setPerspectiveCameraType(PerspectiveCameraTypes.zoom_out));

    dispatch(setReportProgress(0));
    var progressStep = 10;
    var interval = 30000 / 100 * progressStep;
    var crtProgress = 0;
    var intervalID = setInterval(() => {
      crtProgress += progressStep;
      if (crtProgress >= 90) { // stop progress bar at 90%, we don't know the exact amount of time necessary for the report generation
        clearInterval(intervalID);
        intervalID = null;
      }
      dispatch(setReportProgress(crtProgress));
    }, interval);

    // update units
    await dispatch(updateClientUnits());
    // send images
    calculateTabService.prepareReportImage();
    // generate report
    EventManager.once(EVENTS.REPORT_IMAGES_SENT, async (success) => {
      if (success)
        await dispatch(
          generateReportGr(productIdx, diameterIdx, typeIdx, nailProductIdx, nailDiameterIdx, nailTypeIdx, rebarName, isDefault)
        );

      dispatch(setSpinner(false));
      if (intervalID) {
        clearInterval(intervalID);
      }
      dispatch(setReportProgress(100));
    });
  },
  resetCompression: () => dispatch(setCompressionZone(false, [], [], {})),
  cancelFEMCalculation: () => { dispatch(cancelFEMCalculation()); },
  scrollToSelectedResult: (value) => dispatch(scrollToSelectedResult(value)),
  setReportProjectName: (value) => dispatch(setReportProjectName(value)),
  setReportFasteningPoint: (value) => dispatch(setReportFasteningPoint(value)),
  setReportLocation: (value) => dispatch(setReportLocation(value)),
  setReportContactName: (value) => dispatch(setReportContactName(value)),
  setReportCompanyName: (value) => dispatch(setReportCompanyName(value)),
  setReportPhoneNumber: (value) => dispatch(setReportPhoneNumber(value)),
  setReportMailAddress: (value) => dispatch(setReportMailAddress(value)),
  setReportComment: (value) => dispatch(setReportComment(value)),
  setReportLanguage: (value) => dispatch(setReportLanguage(value)),
  setReportProgress: (value) => dispatch(setReportProgress(value)),
  setReportDimensions3D: (value) => dispatch(setReportDimensions3D(value)),
  initCalculateTab: async () => {
    await dispatch(initCalculateTab());
  },
});

export default connect(mapState, mapDispatch)(Calculate);



// WEBPACK FOOTER //
// ./src/views/Calculate/index.js